import { CommonModule } from "@angular/common";
import {
  Component,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatOptionModule } from "@angular/material/core";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgSelectModule } from "@ng-select/ng-select";
import { ICreateFile } from "../interfaces/createFile";
import { MaterialService } from "../../material/material/material.service";
import { FileLoad } from "../interfaces/fileLoad.interface";
import { MaterialGroupService } from "../../material/material-group/material-group.service";
import { MaterialPriceListService } from "../../master/strategy-list/strategy-price-list.service";
import { SubRouteService } from "../../routing/sub-routes/sub-route.service";
import { ReasonVisitService } from "../../master/reason-for-visit/reason-for-visit.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { BusinessPartnerService } from "../../business-partners/business-partner/business-partner.service";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";

@Component({
  selector: "app-format-upload",
  standalone: true,
  imports: [
    CommonModule,
    HoverMenuDirective,
    MatSidenavContainer,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatDialogModule,
    MatSelectModule,
    NgSelectModule,
    MatExpansionModule,
    MatCheckboxModule,
  ],
  templateUrl: "./format-upload.component.html",
  styleUrl: "./format-upload.component.scss",
})
export class FormatUploadComponent {
  @ViewChild("alertDialog") alertDialog!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;

  files = [
    { name: "Maestro.xlsx", size: 458.95, status: "Sin cargar", progress: 0 },
    {
      name: "Maestro_procesamiento.xlsx",
      size: 0.01,
      status: "Completado",
      progress: 100,
    },
  ];

  dataSourceFileMaterial: MatTableDataSource<any> = new MatTableDataSource([]);
  dataSourceFileRoutes: MatTableDataSource<any> = new MatTableDataSource([]);
  dataSourceVisits: MatTableDataSource<any> = new MatTableDataSource([]);
  dataSourceBusinessPartner: MatTableDataSource<any> = new MatTableDataSource(
    []
  );
  displayedColumns = ["actionFile", "name", "size", "status", "action"];

  dataFileMaterial: FileLoad[] = [];
  dataFileRoutes: FileLoad[] = [];
  dataFileVisits: FileLoad[] = [];
  dataFileBusiness: FileLoad[] = [];
  selectDocument: any = null;
  actionChargeItems = [
    { option: 2, name: "Actualizar data" },
    { option: 1, name: "Inicializar desde cero" },
  ];

  fileProgressMaterial = 0;
  loadProgressMaterial: boolean = false;

  fileProgressVisit = 0;
  loadProgressVist: boolean = false;

  fileProgressRoute = 0;
  loadProgressRoute: boolean = false;

  fileProgressBusiness = 0;
  loadProgressBusiness: boolean = false;

  actionCharge: string = "Todo";

  currentCreateFile: ICreateFile = this.initilizateCreateFile();
  optionsFileCharges = [
    { option: 1, label: "Materiales" },
    { option: 2, label: "Grupo de Materiales" },
    { option: 3, label: "Materiales unidad alternativa" },
    { option: 4, label: "Lista de precios" },
    { option: 5, label: "Motivos Visita" },
    { option: 6, label: "Rutas" },
    { option: 7, label: "Socios de Negocio Vendedores" },
    { option: 8, label: "Socios de Negocio Clientes" },
  ];

  optionsFileChargesView: any = [
    { option: 1, label: "Material", selected: true },
    { option: 2, label: "Grupo de Visita", selected: true },
    { option: 3, label: "Rutas", selected: true },
    { option: 4, label: "Socio de Negocio", selected: true },
  ];

  constructor(
    private readonly materiasService: MaterialService,
    private readonly materialGroupService: MaterialGroupService,
    private readonly materialPriceListService: MaterialPriceListService,
    private readonly subRouteService: SubRouteService,
    private readonly reasonVisitService: ReasonVisitService,
    private readonly businessPartnerService: BusinessPartnerService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar
  ) {
  }

  public onChangeOptionLoad() {
    if (this.currentCreateFile.optionLoad === 1) {
      this.dialog
        .open(this.alertDialog, {
          panelClass: "update-modal",
          disableClose: true,
          data: {
            title: "Confirmación de reemplazo de datos",
            description:
              "Los datos actuales serán eliminados y reemplazados con los del documento. ¿Desea continuar?",
          },
        })
        .afterClosed()
        .subscribe(
          (result) => !result && (this.currentCreateFile.optionLoad = null)
        );
    }
  }

  onHandleprocessFile(file: any) {
    switch (file.optionService) {
      case 1:
        this.loadProgressMaterial = true;
        this.fechMaterialFile(file);
        break;
      case 2:
        this.loadProgressMaterial = true;
        this.fechMaterialGroupFile(file);
        break;
      case 3:
        this.loadProgressMaterial = true;
        this.fechMaterialUMFile(file);
        break;
      case 4:
        this.loadProgressMaterial = true;
        this.fechMaterialPriceListFile(file);
        break;
      case 5:
        this.loadProgressVist = true;
        this.fechVisitFile(file);
        break;
      case 6:
        this.loadProgressRoute = true;
        this.fechRoutesFile(file);
        break;
      case 7:
        this.loadProgressBusiness = true;
        this.fechBusinessSallerFile(file);
        break;
      case 8:
        this.loadProgressBusiness = true;
        this.fechBusinessClienttFile(file);
        break;
      default:
    }
  }

  private updateProgress(data) {
    const dataUpload = data.filter(
      (file) => file.status.toLowerCase() === "cargado"
    ).length;
    return (dataUpload * 100) / data.length;
  }

  private initilizateCreateFile() {
    return {
      optionService: null,
      optionLoad: null,
      file: null,
    };
  }

  get isValidateFile() {
    return (
      this.currentCreateFile?.optionService !== null &&
      this.currentCreateFile?.optionLoad !== null &&
      this.currentCreateFile?.file !== null
    );
  }

  // Handle obtener archivo Excel
  public handleFileInput = (event: Event) => {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0]; // Obtiene el primer archivo seleccionado

      this.currentCreateFile.file = file;
      input.value = "";
    }
  };

  public deleteFile(file: any, option: number) {
    switch (option) {
      case 1:
        this.dataFileMaterial = this.dataFileMaterial.filter((f) => f !== file);
        this.dataSourceFileMaterial.data = this.dataFileMaterial;
        break;
      case 2:
        this.dataFileVisits = this.dataFileVisits.filter((f) => f !== file);
        this.dataSourceVisits.data = this.dataFileVisits;
        break;
      case 3:
        this.dataFileRoutes = this.dataFileRoutes.filter((f) => f !== file);
        this.dataSourceFileRoutes.data = this.dataFileRoutes;
        break;
      case 4:
        this.dataFileBusiness = this.dataFileBusiness.filter((f) => f !== file);
        this.dataSourceBusinessPartner.data = this.dataFileBusiness;
        break;
    }
  }

  // Dialogs
  // Subir archivo
  public openDialogAdd() {
    this.currentCreateFile = this.initilizateCreateFile();
    this.dialog
      .open(this.addModal, {
        panelClass: "update-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.showData());
  }

  private showData() {
    const fileNew = {
      file: this.currentCreateFile.file,
      name: this.currentCreateFile.file.name,
      size: this.bytesToMB(this.currentCreateFile.file.size),
      status: "Sin Cargar",
      optionLoad: this.currentCreateFile.optionLoad,
      optionService: this.currentCreateFile.optionService,
    };
    switch (true) {
      case [1, 2, 3, 4].includes(this.currentCreateFile.optionService):
        this.dataFileMaterial.push(fileNew);
        this.dataSourceFileMaterial.data = this.dataFileMaterial;
        this.fileProgressMaterial = this.updateProgress(this.dataFileMaterial);

        break;
      case [6].includes(this.currentCreateFile.optionService):
        this.dataFileRoutes.push(fileNew);
        this.dataSourceFileRoutes.data = this.dataFileRoutes;
        this.fileProgressRoute = this.updateProgress(this.dataFileRoutes);

        break;
      case [5].includes(this.currentCreateFile.optionService):
        this.dataFileVisits.push(fileNew);
        this.dataSourceVisits.data = this.dataFileVisits;
        this.fileProgressVisit = this.updateProgress(this.dataFileVisits);

        break;

      case [7, 8].includes(this.currentCreateFile.optionService):
        this.dataFileBusiness.push(fileNew);
        this.dataSourceBusinessPartner.data = this.dataFileBusiness;
        this.fileProgressVisit = this.updateProgress(this.dataFileBusiness);

        break;

      default:
        break;
    }
  }

  bytesToMB(bytes: number): string {
    const MB = 1024 * 1024;
    return (bytes / MB).toFixed(4); // Convierte a MB y muestra solo 4 dígitos
  }

  public onChangeActionLoad() {
    if (this.currentCreateFile.optionService === 4) {
      this.actionChargeItems = [{ option: 1, name: "Inicializar desde cero" }];
    } else {
      this.actionChargeItems = [
        { option: 2, name: "Actualizar data" },
        { option: 1, name: "Inicializar desde cero" },
      ];
    }

    this.currentCreateFile.optionLoad = null;
  }

  // Eliminar archivo
  public openDialogDelete(file: any, option: number) {
    this.dialog
      .open(this.alertDialog, {
        data: {
          title: "Eliminar Archivo de Carga",
          description:
            "¿Está seguro de que desea eliminar el archivo de carga?",
        },
        panelClass: "update-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.deleteFile(file, option));
  }

  public onHandleActionChange(option) {
    switch (option) {
      case 2:
        this.actionCharge = "Cargados";
        this.dataSourceFileMaterial.data = this.dataFileMaterial.filter(
          (item) => item.status.toLowerCase() === "cargado"
        );
        this.dataSourceFileRoutes.data = this.dataFileRoutes.filter(
          (item) => item.status.toLowerCase() === "cargado"
        );
        this.dataSourceVisits.data = this.dataFileVisits.filter(
          (item) => item.status.toLowerCase() === "cargado"
        );
        break;
      case 3:
        this.actionCharge = "Sin Cargar";
        this.dataSourceFileMaterial.data = this.dataFileMaterial.filter(
          (item) => item.status.toLowerCase() === "sin cargar"
        );
        this.dataSourceFileRoutes.data = this.dataFileRoutes.filter(
          (item) => item.status.toLowerCase() === "sin cargar"
        );
        this.dataSourceVisits.data = this.dataFileVisits.filter(
          (item) => item.status.toLowerCase() === "sin cargar"
        );
        break;
      default:
        this.actionCharge = "Todo";
        this.dataSourceFileMaterial.data = this.dataFileMaterial;
        this.dataSourceFileRoutes.data = this.dataFileRoutes;
        this.dataSourceVisits.data = this.dataFileVisits;
        break;
    }
  }

  public toggleElement(itemSelect) {
    if (this.selectDocument && this.selectDocument.name === itemSelect.name) {
      this.selectDocument = null;
      return;
    }
    this.selectDocument = itemSelect;
  }

  public dowloandFileData(option) {
    let url = "";

    switch (option) {
      case 1:
        url = this.materiasService.getMaterialExcelData();

        break;
      case 2:
        url = this.materialGroupService.getMaterialGroupExcelData();
        break;
      case 3:
        url = this.materiasService.getMaterialUMExcelData();
        break;
      case 4:
        url = this.materialPriceListService.getMaterilaPriceListExcelData();
        break;
      case 5:
        url = this.reasonVisitService.getResonVistExcelData();
        break;
      case 6:
        url = this.subRouteService.getRouteExcelData();
        break;
      case 7:
        url = this.businessPartnerService.getBusinessPartnerExcelData();
        break;
      case 8:
        url = this.businessPartnerService.getBusinessPartnerClientExcelData();
        break;
      default:
    }

    if (!url) {
      this.snackBar.open("Plantilla no disponible.", "Cerrar", {
        duration: 3000,
      });
      return;
    }
    window.open(url);
  }

  public updateFile(event, fileLoad: FileLoad) {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0]; // Obtiene el primer archivo seleccionado

      fileLoad.file = file;
      fileLoad.name = file.name;
      fileLoad.status = "Sin cargar";
    }
  }

  private fechMaterialFile(fileLaod: FileLoad) {

    this.materiasService
      .saveFileMaterila(fileLaod.file, fileLaod.optionLoad.toString())
      .subscribe((res) => {
        fileLaod.status = "Cargado";

        this.fileProgressMaterial = this.updateProgress(
          this.dataSourceFileMaterial.data
        );
        this.loadProgressMaterial = false;
        //     this.cdr.detectChanges();
      });
  }

  private fechMaterialGroupFile(fileLaod: FileLoad) {
    this.materialGroupService
      .saveFileMaterialGroup(fileLaod.file, fileLaod.optionLoad.toString())
      .subscribe((res) => {
        fileLaod.status = "Cargado";
        this.fileProgressMaterial = this.updateProgress(this.dataFileMaterial);
        this.loadProgressMaterial = false;
      });
  }

  private fechMaterialUMFile(fileLaod: FileLoad) {

    this.materiasService
      .saveFileMaterilaUM(fileLaod.file, fileLaod.optionLoad.toString())
      .subscribe((res) => {
        fileLaod.status = "Cargado";
        this.fileProgressMaterial = this.updateProgress(this.dataFileMaterial);
        this.loadProgressMaterial = false;
      });
  }

  private fechMaterialPriceListFile(fileLaod: FileLoad) {

    this.materialPriceListService
      .saveFileMaterilaPriceList(fileLaod.file)
      .subscribe((res) => {
        fileLaod.status = "Cargado";
        this.fileProgressMaterial = this.updateProgress(this.dataFileMaterial);
        this.loadProgressMaterial = false;
      });
  }

  private fechRoutesFile(fileLaod: FileLoad) {

    this.subRouteService
      .saveFileRoute(fileLaod.file, fileLaod.optionLoad.toString())
      .subscribe((res) => {
        fileLaod.status = "Cargado";
        this.fileProgressRoute = this.updateProgress(this.dataFileRoutes);
        this.loadProgressRoute = false;
      });
  }

  private fechVisitFile(fileLaod: FileLoad) {
    this.reasonVisitService
      .saveFileResonFile(fileLaod.file, fileLaod.optionLoad.toString())
      .subscribe((res) => {
        fileLaod.status = "Cargado";
        this.fileProgressVisit = this.updateProgress(this.dataFileVisits);
        this.loadProgressVist = false;
      });
  }

  private fechBusinessClienttFile(fileLaod: FileLoad) {

    this.businessPartnerService
      .saveFileBusinessPartnerClientFile(
        fileLaod.file,
        fileLaod.optionLoad.toString()
      )
      .subscribe({
        next: (res) => {
          fileLaod.status = "Cargado";
          this.fileProgressBusiness = this.updateProgress(
            this.dataFileBusiness
          );
          this.loadProgressBusiness = false;
        },
        error: (err) => {
          this.loadProgressBusiness = false;
        },
      });
  }

  private fechBusinessSallerFile(fileLaod: FileLoad) {

    this.businessPartnerService
      .saveFileBusinessPartnerFile(
        fileLaod.file,
        fileLaod.optionLoad.toString()
      )
      .subscribe({
        next: (res) => {
          fileLaod.status = "Cargado";
          this.fileProgressBusiness = this.updateProgress(
            this.dataFileBusiness
          );
          this.loadProgressBusiness = false;
        },
        error: (err) => {
          this.loadProgressBusiness = false;
        },
      });
  }
}
